<template>
  <el-dialog
    :visible.sync="visible"
    title="收货入库"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%"
    top="5vh"
    :append-to-body="true"
    v-loading="loading"
  >
    <div class="dialog-content" style="padding-right:20px;">
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
      >
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="入库时间：" prop="operateTime">
                <el-date-picker
                  v-model="dataForm.operateTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="选择出入库时间"
                  size="mini"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收货仓库：" prop="storageId">
                <storages v-model="dataForm.storageId" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物流公司：" prop="carriageMan">
                <dict v-model="dataForm.carriageMan" dictName="carriage_man" size="mini"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物流号：" prop="carriageNo">
                <el-input v-model="dataForm.carriageNo" size="mini"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注：" prop="remark">
                <el-input
                    size="mini"
                  v-model="dataForm.remark"
                  placeholder="备注"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="凭证照片：" prop="imgs">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>

          <el-table :data="dataForm.detailList" border style="width: 100%">
            <el-table-column
              type="index"
              width="50"
              label="行号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column label="品名" prop="name" align="center">
            </el-table-column>
            <el-table-column label="颜色" prop="color" align="center">
            </el-table-column>
            <el-table-column label="规格" prop="size" align="center">
            </el-table-column>
            <el-table-column label="幅宽" prop="attr1" align="center">
            </el-table-column>
            <el-table-column label="克重" prop="attr2" align="center">
            </el-table-column>
            <el-table-column label="收货单价" prop="count" align="center">
              <template slot-scope="scope">
                <el-form-item
                    :prop="'detailList.' + scope.$index + '.price'"
                    :rules="detailRule.price"
                    label-width="0"
                    style="margin-top: 20px"
                    size="mini"
                >
                  <el-input v-model="scope.row.price" size="mini"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              label="收货数量"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="'detailList.' + scope.$index + '.realCount'"
                  :rules="detailRule.count"
                  label-width="0"
                  style="margin-top: 20px"
                  size="mini"
                >
                  <el-input v-model="scope.row.realCount" size="mini"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
      </el-form>
    </div>
    <template slot="footer">
      <el-button @click="cancel()">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import MultipleImageUpload from "@/components/MultipleImageUpload";
import SaveRule from "./form-rule";
import moment from "moment";
export default {
  mixins: [SaveRule],
  components: { MultipleImageUpload },
  data() {
    return {
      id: "",
      storageId: "",
      dataForm: {},
      visible: false,
      loading: false,
    };
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    async getPurchase(id) {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get(`/trade/purchase/${id}`);
        this.loading = false;
        res.data.detailList = [
          {
            code: res.data.productCode,
            name: res.data.productName,
            color: res.data.color,
            size: res.data.size,
            attr1: res.data.attr1,
            attr2: res.data.attr2,
            count: res.data.count,
            price: res.data.amount,
            realCount: "",
            productId: res.data.productId,
          },
        ];

        this.dataForm.factoryId = res.data.factoryId;
        this.dataForm.factoryName = res.data.factoryName;
        this.dataForm.purchaseAgreementId = res.data.id;
        this.$set(this.dataForm,'detailList',res.data.detailList)
      } catch (e) {
        this.loading = false;
      }
    },

    async reset() {
      this.imgArr = [];
      this.dataForm = {
        id: "",
        remark: "",
        receiptCode:'',
        operateTime: moment().format("yyyy-MM-DD"),
        storageId: this.storageId,
        storageName: "",
        carriageNo: "",
        carriageMan: "",
        imgs: "",
        purchaseAgreementId: "",
        distribution: "",
        factoryId: "",
        factoryName: "",
        detailList: [],
      };
    },
    async init() {
      this.reset();
      await this.getPurchase(this.id);
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].clearValidate();
        }
      });
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          if (
            !this.dataForm.detailList ||
            this.dataForm.detailList.length === 0
          ) {
            return this.$message.error("明细不能为空");
          }
          let postForm = {
            receiptCode:this.dataForm.receiptCode,
            operateTime: this.dataForm.operateTime,
            carriageNo: this.dataForm.carriageNo,
            carriageMan: this.dataForm.carriageMan,
            purchaseAgreementId: this.dataForm.purchaseAgreementId,
            imgs: this.dataForm.imgs,
            remark: this.dataForm.remark,
            storageId: this.dataForm.storageId,
            sourceId: this.id,
            detailList: [],
          };
          this.dataForm.detailList.forEach((item) => {
            if(!item.realCount||item.realCount===0){
              return;
            }
            postForm.detailList.push({
              id: item.id,
              count: item.realCount,
              productId: item.productId,
              remark: item.remark,
            });
          });
          if(postForm.detailList.length===0){
            return this.$message.error('请输入收货数量')
          }
          this.loading = true;
          this.$http
            .post("/trade/purchase/check/in", postForm)
            .then(({ data: res }) => {
              this.loading = false;
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
            });
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
